"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const LocationAccessibility = ({ location }) => {
    const { accessibility = [] } = location;
    if (!accessibility || !accessibility.length)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null, accessibility.map((item) => (react_1.default.createElement("li", { key: item.name, "data-testid": item['_entity_id'] }, item.name)))));
};
exports.default = LocationAccessibility;
//# sourceMappingURL=location-accessibility.js.map